/* BKP slider: horizontale scroll-rij met prev/next-knoppen.
   Gebruik: <div data-bkp-slider><button data-bkp-prev>...<button data-bkp-next>...<div data-bkp-track>items</div></div> */
(function () {
  function init(root) {
    // script wordt door meerdere secties geladen: dubbele init geeft dubbele
    // click-listeners en twee vechtende animaties (haperen) — dus 1x wiren
    if (root.dataset.bkpSliderInit) return;
    root.dataset.bkpSliderInit = '1';
    var track = root.querySelector('[data-bkp-track]');
    var prev = root.querySelector('[data-bkp-prev]');
    var next = root.querySelector('[data-bkp-next]');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var itemsPerClick = window.matchMedia('(max-width: 749px)').matches ? 1 : 2;
      return (item.getBoundingClientRect().width + gap) * itemsPerClick;
    }
    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      // Houd beide richtingen zichtbaar zodra er overflow is. De onbruikbare
      // richting wordt gedimd; zo blijft de bediening overal op de site gelijk.
      prev.hidden = next.hidden = !overflow;
      if (!overflow) return;
      prev.disabled = atStart;
      next.disabled = atEnd;
    }
    // Eigen easing-animatie: native smooth scroll (JS én CSS) botst met scroll-snap
    // in Chromium en springt terug naar 0.
    var anim = null;
    function glide(delta) {
      if (anim) cancelAnimationFrame(anim);
      var from = track.scrollLeft;
      var to = Math.max(0, Math.min(from + delta, track.scrollWidth - track.clientWidth));
      // verborgen tab of reduced-motion: rAF draait niet / animatie ongewenst -> direct springen
      if (document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.scrollLeft = to; update(); return;
      }
      // Mobiel gebruikt scroll-snap voor handmatig swipen. Tijdens een door de
      // pijlen gestarte animatie moet snap tijdelijk uit, anders corrigeert Safari/
      // Chromium elke tussenstap en lijkt de kaart zonder beweging te verspringen.
      track.classList.add('is-gliding');
      var start = null, dur = 380;
      function tick(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        track.scrollLeft = from + (to - from) * e;
        if (p < 1) anim = requestAnimationFrame(tick);
        else {
          track.scrollLeft = to;
          track.classList.remove('is-gliding');
          anim = null;
          update();
        }
      }
      anim = requestAnimationFrame(tick);
    }
    prev.addEventListener('click', function () { glide(-step()); });
    next.addEventListener('click', function () { glide(step()); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  document.querySelectorAll('[data-bkp-slider]').forEach(init);

  // kennisbank: bloglijst als slider met pijlen (Horizon-sectie, dus knoppen via JS toevoegen;
  // op desktop past alles op één rij en verbergt update() de knoppen vanzelf)
  var blogSec = document.querySelector('[id$="__bkp_blog"] .section');
  if (blogSec && !blogSec.dataset.bkpSliderInit) {
    var blogList = blogSec.querySelector('.resource-list');
    if (blogList) {
      var ARROW = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
      blogList.setAttribute('data-bkp-track', '');
      var nav = document.createElement('div');
      nav.className = 'bkp-slider__nav bkp-slider__nav--blog';
      nav.innerHTML = '<button type="button" class="bkp-slider__btn" data-bkp-prev aria-label="Vorige">' + ARROW + '</button>' +
                      '<button type="button" class="bkp-slider__btn" data-bkp-next aria-label="Volgende">' + ARROW + '</button>';
      var blogHead = blogSec.querySelector('.bkp-blog__head');
      if (blogHead) {
        blogHead.appendChild(nav);
      } else {
        blogList.parentNode.insertBefore(nav, blogList);
      }
      blogSec.setAttribute('data-bkp-slider', '');
      init(blogSec);
    }
  }
})();
